module.exports = __webpack_public_path__ + "main/assets/public/share-icons/twitter.1f7b9f7f25ec48f9.svg";